import styled from '@emotion/styled';
import { ThemeContext } from '@shared/components/loading/ThemeContextLoader';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FullLogo } from '../core/images/icons/brand';
import FullLogoWhite from '../core/images/icons/brand/FullLogoWhite';
import { CenterRowWrapper } from '../core/layouts/CommonLayoutStyles';
import { Tag } from '../core/text/ContentTypography';
import {
    InlineBodyMedium,
    LandingBase,
    LandingBodyLarge,
    LandingButton,
    LandingOnboardingCard,
    LandingTextButton,
} from '../core/text/LandingTypography';
import { BodyLarge } from '../core/text/Typography';

interface ILoginLandingProps {
    isExperimentalDevice?: boolean;
    isLoading?: boolean;
    showLoading?: () => void;
    signInUrl: string;
    signUpUrl: string;
}

export default function LoginLanding({
    isExperimentalDevice,
    isLoading,
    showLoading,
    signInUrl,
    signUpUrl,
}: ILoginLandingProps) {
    const { t } = useTranslation();
    const { theme } = useContext(ThemeContext);

    return (
        <LandingBase>
            <LandingOnboardingCard>
                {isExperimentalDevice && <StyledTag>{t('common:beta')}</StyledTag>}
                {theme == 'light' ? <FullLogo width={350} /> : <FullLogoWhite width={350} />}
                <LandingBodyLarge>{t('common:login.description')}</LandingBodyLarge>

                {isLoading ? (
                    <BodyLarge>{t('common:login.loading')}</BodyLarge>
                ) : (
                    <>
                        <LandingButton href={signUpUrl}>{t('common:login.create')}</LandingButton>
                        <CenterRowWrapper>
                            <InlineBodyMedium>{t('common:login.existingAccount')}</InlineBodyMedium>
                            <LandingTextButton variant="context" onClick={showLoading} href={signInUrl}>
                                {t('common:login.signIn')}
                            </LandingTextButton>
                        </CenterRowWrapper>
                    </>
                )}
            </LandingOnboardingCard>
        </LandingBase>
    );
}

const StyledTag = styled(Tag)`
    position: relative;
    top: 30px;
`;
